// Simple confetti animation utility
export const triggerConfetti = () => {
  const duration = 3 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  const interval = setInterval(function() {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);
    
    // Create confetti-like elements
    for (let i = 0; i < particleCount; i++) {
      const confetti = document.createElement('div');
      confetti.style.position = 'fixed';
      confetti.style.width = '10px';
      confetti.style.height = '10px';
      confetti.style.backgroundColor = ['#FDE047', '#FB923C', '#10B981', '#3B82F6', '#EC4899'][Math.floor(Math.random() * 5)];
      confetti.style.left = randomInRange(0, window.innerWidth) + 'px';
      confetti.style.top = '-20px';
      confetti.style.opacity = '1';
      confetti.style.transform = 'rotate(' + randomInRange(0, 360) + 'deg)';
      confetti.style.zIndex = '9999';
      confetti.style.pointerEvents = 'none';
      confetti.style.borderRadius = '50%';
      
      document.body.appendChild(confetti);

      const xVelocity = randomInRange(-2, 2);
      const yVelocity = randomInRange(2, 6);
      const rotation = randomInRange(0, 10);
      let yPos = -20;
      let xPos = parseFloat(confetti.style.left);
      let currentRotation = 0;

      const animate = () => {
        yPos += yVelocity;
        xPos += xVelocity;
        currentRotation += rotation;
        
        confetti.style.top = yPos + 'px';
        confetti.style.left = xPos + 'px';
        confetti.style.transform = 'rotate(' + currentRotation + 'deg)';
        confetti.style.opacity = Math.max(0, 1 - (yPos / window.innerHeight));

        if (yPos < window.innerHeight) {
          requestAnimationFrame(animate);
        } else {
          confetti.remove();
        }
      };

      animate();
    }
  }, 250);
};
